import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    listConfigurationsByIdSendings: `${baseURL}/sendings/configurations`,
    getRetryConfiguration: idConf =>
      `${baseURL}/configuration/${encodeURIComponent(idConf)}/retry`,
    executeConfigurationProcessing: idConf =>
      `${baseURL}/configuration/${encodeURIComponent(idConf)}/process`,
    cancelConfigurationProcessing: idConf =>
      `${baseURL}/configuration/${encodeURIComponent(idConf)}/process`,
    simulateConfigurationProcessing: `${baseURL}/configuration/simulate`,
    getLastConfigurationsByInvio: idInvio =>
      `${baseURL}/sending/${encodeURIComponent(idInvio)}/configuration/last`,
    getConfigurations: params =>
      `${baseURL}/configurations?${encodeParams(params)}`,
    getQueueingConfigurationById: idInvio =>
      `${baseURL}/configuration/${encodeURIComponent(idInvio)}`,
    saveQueueingConfiguration: `${baseURL}/configuration`,
    deleteRecipients: idConf =>
      `${baseURL}/configuration/${encodeURIComponent(idConf)}`,
    getConfiguration: idConf =>
      `${baseURL}/configuration/${encodeURIComponent(idConf)}`,
    getSendingsTotalCost: () => `${baseURL}/sms/sendings/totalcost`,
    getQueuedSmsRecipientsCountby: (idSending, params) =>
      `${baseURL}/sms/sending/${idSending}/recipients/countby?${encodeParams(
        params
      )}`,
    resetSendingQueue: idSending =>
      `${baseURL}/email/sending/${encodeURIComponent(idSending)}/reset`,
    getSenderInEmailQueue: idSending =>
      `${baseURL}/email/sending/${encodeURIComponent(idSending)}/senders`,
    updateSenderInEmailQueue: idSending =>
      `${baseURL}/email/sending/${encodeURIComponent(idSending)}/sender`,
    getQueuedEmailRecipients: (idSending, params) =>
      `${baseURL}/email/sending/${idSending}/recipients?${encodeParams(
        params
      )}`,
    removeRecipientFromEmailSendingQueue: (idSending, idRecipient) =>
      `${baseURL}/email/sending/${idSending}/recipient/${idRecipient}`,
    clearEmailSendingQueue: idSending => `${baseURL}/email/sending/${idSending}`
  }
})(process.env.BEQUEUE_URL)

export const beQueueListConfigurationsByIdSendings = IdSendings => {
  const url = endpoints.listConfigurationsByIdSendings
  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ IdSendings })
  }).then(extractApiData)
}

export const beQueueGetRetryConfiguration = idConf => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRetryConfiguration(idConf)
  }).then(extractApiData)
}

export const beQueueResetSendingQueue = idSending => {
  return apiWrapper({
    method: 'put',
    url: endpoints.resetSendingQueue(idSending)
  }).then(extractApiData)
}

export const beQueueExecuteConfigurationProcessing = idConf => {
  return apiWrapper({
    method: 'post',
    url: endpoints.executeConfigurationProcessing(idConf)
  }).then(extractApiData)
}

export const beQueueCancelConfigurationProcessing = idConf => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.cancelConfigurationProcessing(idConf)
  }).then(extractApiData)
}

export const beQueueSimulateConfigurationProcessing = config => {
  return apiWrapper({
    method: 'post',
    url: endpoints.simulateConfigurationProcessing,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(config)
  }).then(extractApiData)
}

/**
 * @description Gets the last configurations by invio
 * @param {number} idSending
 * @returns {ConfigOut}
 */
export const beQueueGetLastConfigurationsByInvio = idSending => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getLastConfigurationsByInvio(idSending)
  }).then(extractApiData)
}

export const beQueueGetConfigurations = params => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getConfigurations(params)
  }).then(extractApiData)
}

export const beQueueGetQueuedSmsRecipientsCountby = (idSending, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getQueuedSmsRecipientsCountby(idSending, params)
  }).then(extractApiData)
}

export const beQueueGetQueuedEmailRecipients = (idSending, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getQueuedEmailRecipients(idSending, params)
  }).then(extractApiData)
}
export const beQueueGetConfiguration = idConf => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getConfiguration(idConf)
  }).then(extractApiData)
}

/**
 * @description Gets the configurations by its id
 * @param {number} idConf
 * @returns {Configuration}
 */
export const beQueueGetConfigurationById = idConf => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getQueueingConfigurationById(idConf)
  }).then(extractApiData)
}

export const beQueueSaveQueueingConfiguration = config => {
  return apiWrapper({
    method: 'post',
    url: endpoints.saveQueueingConfiguration,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(config)
  }).then(extractApiData)
}

export const beQueueDeleteConfigurationById = idConf => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteRecipients(idConf)
  }).then(extractApiData)
}

export const beQueueGetSendingsTotalCost = data => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSendingsTotalCost(),
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}

export const beQueueGetSenderInEmailQueue = idSending => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSenderInEmailQueue(idSending)
  }).then(extractApiData)
}
export const beQueueUpdateSenderInEmailQueue = (idSending, data) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateSenderInEmailQueue(idSending),
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}

export const beQueueRemoveRecipientFromEmailSendingQueue = (
  idSending,
  idRecipient
) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.removeRecipientFromEmailSendingQueue(idSending, idRecipient)
  }).then(extractApiData)
}

export const beQueueClearEmailSendingQueue = idSending => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.clearEmailSendingQueue(idSending)
  }).then(extractApiData)
}

export const BEQUEUE_CONFIG_ACTION_SIMULATION = 'Simulation'
export const BEQUEUE_CONFIG_ACTION_MAIL = 'Mail'
export const BEQUEUE_CONFIG_ACTION_SMS = 'Sms'

export const BEQUEUE_CONFIG_TYPE_EVERYBODY = 'Everybody'
export const BEQUEUE_CONFIG_TYPE_GROUPS = 'TheseGroupsOnly'
export const BEQUEUE_CONFIG_TYPE_MANUAL = 'ManualSelection'

export const BEQUEUE_CONFIG_FILTER_COND_OR = 'Or'
export const BEQUEUE_CONFIG_FILTER_COND_AND = 'And'

export const BEQUEUE_CONFIG_FILTER_COND_OR_NUM = 1
export const BEQUEUE_CONFIG_FILTER_COND_AND_NUM = 0

export const BEQUEUE_CONFIG_INCLUDE = 'Include'
export const BEQUEUE_CONFIG_EXCLUDE = 'Exclude'

export const BEQUEUE_CONFIG_STATE_CANCELLED = 'Cancelled'
export const BEQUEUE_CONFIG_STATE_COMPLETED = 'Completed'
export const BEQUEUE_CONFIG_STATE_DISCARDED = 'Discarded'
export const BEQUEUE_CONFIG_STATE_FAILED = 'Failed'
export const BEQUEUE_CONFIG_STATE_RUNNING = 'Running'
export const BEQUEUE_CONFIG_STATE_RETRIED = 'Retried'
export const BEQUEUE_CONFIG_STATE_TOEXECUTE = 'ToExecute'
export const BEQUEUE_CONFIG_STATE_UPDATING = 'Updating'
